import React, { useState } from "react";
import img1 from "../asset/img/dashboard.png";
import { Link, useNavigate } from "react-router-dom";
import { buildApiUrl, fetchJsonWithRetry } from "../config/api";
function Homepage() {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [inputs1, setInputs1] = useState({});
  const [inputs2, setInputs2] = useState({});
  const [showerror, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [forgotStatus, setForgotStatus] = useState("");

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleChange1 = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs1((values) => ({ ...values, [name]: value }));
  };
  const handleChange2 = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs2((values) => ({ ...values, [name]: value }));
  };
  const openModal3 = () => {
    var modal2 = document.getElementById("forgetModal");
    console.log("CC");
    modal2.style.display = "block";
  };
  const closeModal3 = (event) => {
    var modal2 = document.getElementById("forgetModal");
    modal2.style.display = "none";
  };
  const openModal4 = () => {
    var modal4 = document.getElementById("forgetModal1");
    console.log("CC");
    modal4.style.display = "block";
  };
  const closeModal4 = (event) => {
    var modal4 = document.getElementById("forgetModal1");
    modal4.style.display = "none";
  };
  const forgetEmail = async (event) => {
    event.preventDefault();
    setForgotStatus("");
    try {
      const {
        response,
        data,
        error: requestError,
      } = await fetchJsonWithRetry(
        buildApiUrl("auth/email"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: inputs1.fmail }),
        },
        { retries: 1, retryDelayMs: 1000 },
      );

      if (response?.ok && data?.success === true) {
        setForgotStatus(
          "Email sent successfully. Check your inbox for the OTP.",
        );
        closeModal3();
        openModal4();
      } else if (response?.status === 404) {
        setForgotStatus(data?.message || "User not found");
      } else if (
        response?.status === 500 &&
        data?.message === "Mail configuration is missing"
      ) {
        setForgotStatus("Mail config missing on backend");
      } else if (requestError) {
        setForgotStatus("Failed to connect with server");
      } else {
        setForgotStatus(data?.message || "Failed to send email");
      }
    } catch (error) {
      console.log("Error ", error);
      setForgotStatus("Failed to send email");
    }
  };

  const doLogin = async (event) => {
    event.preventDefault();
    console.log("Clicked", inputs);
    var paramsjson = {
      email: inputs.email,
      password: inputs.pass,
    };
    var params = JSON.stringify(paramsjson);
    try {
      const {
        response,
        data,
        error: requestError,
      } = await fetchJsonWithRetry(
        buildApiUrl("auth/login"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: params,
        },
        { retries: 3, retryDelayMs: 2000 },
      );

      if (response?.ok && data?.success === true) {
        localStorage.setItem("name", data.name);
        localStorage.setItem("email", data.email);
        localStorage.setItem("token", data.token);
        localStorage.setItem("islogin", true);
        navigate("/dashboard");
      } else if (response && [502, 503, 504].includes(response.status)) {
        setShowError(true);
        setError("Backend is waking up. Please try again in a few seconds.");
      } else if (requestError) {
        setShowError(true);
        setError("Failed to connect with server");
      } else {
        setShowError(true);
        setError("Invalid Credentials");
      }
    } catch (error) {
      console.log("Error ", error);
      setShowError(true);
      setError("Failed to connect with server");
    }
  };
  const updatePass = (event) => {
    event.preventDefault();
    setShowError(false);
    setError("");
    setForgotStatus("");

    if (inputs2.fnpsw !== inputs2.fcnfpsw) {
      setShowError(true);
      setError("Password and confirm password do not match");
      return;
    }

    fetchJsonWithRetry(
      buildApiUrl("auth/forget"),
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: inputs1.fmail,
          otp: inputs2.otp,
          password: inputs2.fnpsw,
          confirmPassword: inputs2.fcnfpsw,
        }),
      },
      { retries: 1, retryDelayMs: 1000 },
    )
      .then(({ response, data, error: requestError }) => {
        if (response?.ok && data?.success === true) {
          setForgotStatus(data?.message || "Password updated successfully");
          closeModal4();
          return;
        }

        if (response?.status === 410) {
          setShowError(true);
          setError(data?.message || "OTP expired. Please request a new one.");
          return;
        }

        if (response?.status === 403) {
          setShowError(true);
          setError(data?.message || "Invalid OTP");
          return;
        }

        if (requestError) {
          setShowError(true);
          setError("Failed to connect with server");
          return;
        }

        setShowError(true);
        setError(data?.message || "Failed to update password");
      })
      .catch((error) => {
        console.log("Error ", error);
        setShowError(true);
        setError("Failed to update password");
      });
  };
  return (
    <div className="container">
      <div className="leftcontainer">
        <p>Welcome to Expense Tracker</p>
        <p>Manage all your expenses here</p>
        <img src={img1} alt="Expense dashboard illustration" />
      </div>
      <div className="rightcontainer">
        <div id="forgetModal" className="modal3">
          <div className="formcard">
            <div>
              <h2 style={{ alignSelf: "center" }}>Forgot Password ?</h2>
            </div>
            <form onSubmit={forgetEmail}>
              <div>
                <label>Email</label>
                <input
                  required
                  type="email"
                  placeholder="Enter your Email ID"
                  value={inputs1.fmail || ""}
                  onChange={handleChange1}
                  name="fmail"
                />
              </div>

              <div>
                <button>Send OTP</button>
              </div>
              <div>
                <button type="button" onClick={closeModal3}>
                  Cancel
                </button>
              </div>

              {forgotStatus ? (
                <div>
                  <span style={{ color: "green", alignSelf: "center" }}>
                    {forgotStatus}
                  </span>
                </div>
              ) : null}
            </form>
          </div>
        </div>
        <div id="forgetModal1" className="modal4">
          <div className="formcard">
            <div>
              <h2 style={{ alignSelf: "center" }}>Update Password</h2>
            </div>
            <form onSubmit={updatePass}>
              <div>
                <label>OTP</label>
                <input
                  required
                  type="text"
                  placeholder="Enter your OTP"
                  value={inputs2.otp || ""}
                  onChange={handleChange2}
                  name="otp"
                />
              </div>
              <div>
                <label>New Password</label>
                <input
                  required
                  type="password"
                  placeholder="Enter your new password"
                  value={inputs2.fnpsw || ""}
                  onChange={handleChange2}
                  name="fnpsw"
                />
              </div>
              <div>
                <label>Confirm New Password</label>
                <input
                  required
                  type="password"
                  placeholder="Confirm your new password"
                  value={inputs2.fcnfpsw || ""}
                  onChange={handleChange2}
                  name="fcnfpsw"
                />
              </div>
              <div>
                <button>Submit</button>
              </div>
              <div>
                <button type="button" onClick={closeModal4}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="formcard">
          <div>
            <h2 style={{ alignSelf: "center" }}>Login</h2>
          </div>
          <form onSubmit={doLogin}>
            <div>
              <label>Email</label>
              <input
                required
                type="email"
                placeholder="Enter your email"
                value={inputs.email || ""}
                onChange={handleChange}
                name="email"
              />
            </div>
            <div>
              <label>Password</label>
              <input
                required
                type="password"
                placeholder="Enter your Password"
                value={inputs.pass || ""}
                onChange={handleChange}
                name="pass"
              />
            </div>
            {showerror ? (
              <div>
                <span style={{ color: "red", alignSelf: "center" }}>
                  {error}
                </span>
              </div>
            ) : null}

            <div>
              <button>Login</button>
            </div>
          </form>
          <div>
            <button
              onClick={openModal3}
              style={{
                backgroundColor: "white",
                color: "black",
                border: "2px solid black",
              }}
            >
              Forgot Password
            </button>
          </div>
          <div>
            <span style={{ alignSelf: "center" }}>
              Not a user ?<Link to="/register">Register</Link>{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
